// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__aime_55417a', '__aime_Fallback_55417a'"},"className":"__className_55417a","variable":"__variable_55417a"};